import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class ObjectUrlService {
  private readonly sanitizer = inject(DomSanitizer);

  private objectUrls: string[] = [];

  /** Track and sanitize already existing objectUrl */
  addObjectUrl(objectUrl: string): string {
    this.objectUrls.push(objectUrl);
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl) as string;
  }

  createObjectUrl(object: File | Blob): string {
    const objectUrl = window.URL.createObjectURL(object);
    this.objectUrls.push(objectUrl);
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl) as string;
  }

  revokeObjectUrls(): void {
    this.objectUrls.forEach((objectUrl) => {
      window.URL.revokeObjectURL(objectUrl);
    });
    this.objectUrls = [];
  }
}
